/**
 * Stripe Paywall Feature Flag Configuration
 *
 * This file controls which creator handles have access to the Stripe paywall UI features.
 * Changes to this list require a code deployment.
 *
 * Features controlled:
 * - Premium Access section in Settings page
 * - Premium content controls in post/link creation modals
 * - Premium badges on posts
 * - Subscription tier management UI
 *
 * Note: Backend RPCs are NOT gated - all creators can use them for testing purposes.
 * This is frontend-only UI visibility control.
 */

/**
 * List of creator handles with Stripe paywall UI access enabled.
 * Add handles here to enable the feature for specific creators.
 *
 * Example:
 * export const STRIPE_PAYWALL_ENABLED_CREATORS: string[] = [
 *   "johndoe",
 *   "janedoe",
 * ];
 */
export const STRIPE_PAYWALL_ENABLED_CREATORS: string[] = ["artem"];

/**
 * Check if a creator handle has Stripe paywall UI features enabled.
 *
 * @param handle - The creator's handle (from authentication_influencer.handle)
 * @returns true if the creator should see premium UI features, false otherwise
 */
export function isStripePaywallEnabled(handle: string | undefined): boolean {
  if (!handle) return false;

  if (location.port === "8080") return true;

  return STRIPE_PAYWALL_ENABLED_CREATORS.includes(handle);
}
